import Badge from '@repo/ui/badge'
import { BuildingThreeIcon, TicketIcon } from '@repo/ui/icons'

import { currencyEnumMapping } from '../../../../lib/types/enums/common/currency.enum'
import { missionStaffStatusEnumMapping } from '../../../../lib/types/enums/mission/mission-staff-status.enum'
import { MissionTypeEnum } from '../../../../lib/types/enums/mission/mission-type.enum'
import { Mission } from '../../../../lib/types/models/mission/mission'
import { MissionProperties } from '../../../../lib/types/models/mission/properties.mission'
import { AffectedUser } from '../affected-lists/utils'
import { MissionProperty } from './mission-clickable-badge'

type Props = {
  mission: Mission
  affectedUser: AffectedUser
}

const MissionStaffBadge = ({ mission, affectedUser }: Props) => {
  return (
    <div className={'rounded p-1 flex gap-1 border border-green-light'}>
      <Badge
        text={MissionProperties.getMissionStaffNameAndBirthDate(affectedUser)}
        variant={missionStaffStatusEnumMapping[affectedUser.status].variant}
      />

      {mission.missionType.type === MissionTypeEnum.STAFF && (
        <>
          {mission.missionType.ticketingRequired && (
            <MissionProperty
              icon={(color) => <TicketIcon color={color} />}
              condition={affectedUser.ticketingHandled}
              conditionType="ticketingHandled"
              missionId={mission.id}
              type={MissionTypeEnum.STAFF}
              id={affectedUser.id}
            />
          )}
          {mission.missionType.hotelRequired && (
            <MissionProperty
              icon={(color) => <BuildingThreeIcon color={color} />}
              condition={affectedUser.hotelHandled}
              conditionType="hotelHandled"
              missionId={mission.id}
              id={affectedUser.id}
              type={MissionTypeEnum.STAFF}
            />
          )}
        </>
      )}
      {affectedUser.budget && (
        <MissionProperty
          text={`${affectedUser.budget.toString()}${affectedUser.budgetCurrency ? currencyEnumMapping[affectedUser.budgetCurrency].symbol : ''}`}
          condition={affectedUser.budgetHandled}
          conditionType="budgetHandled"
          missionId={mission.id}
          id={affectedUser.id}
          type={mission.missionType.type}
        />
      )}
    </div>
  )
}

export default MissionStaffBadge
